App.prototype.reloadBasketPage = function (cart) {
    if ($('.basket-page').length) {
        var el_min_order_price = $('#minimum-order-price'),
            data_min_order_price = $('[data-min-order-price]'),
            el_initial_basket_price = $('[data-initial-basket-price]');

        if (
            (el_min_order_price.length && el_min_order_price.text() < cart.total) ||
            (el_initial_basket_price.length && el_initial_basket_price.data('initial-basket-price') > cart.total && cart.total <= data_min_order_price.data('min-order-price'))
        ) {
            location.reload()
            return;
        }
    }
}
